export enum NOTIFICATION_TYPES {
  ENERGY_LOSS = "energy_loss",
  REPAIR_REQUEST_CREATED = "repair_request_created",
  REPAIR_REQUEST_UPDATED = "repair_request_updated",
  WARNING = "warning",
  CRITICAL = "critical",
  PREDICTIVE_MAINTENANCE_CREATED = "predictive_maintenance_created",
  PREDICTIVE_MAINTENANCE_UPDATED = "predictive_maintenance_updated",
  INTERNAL_SERVICE_REMINDER = "internal_service_reminder",
  EXTERNAL_SERVICE_REMINDER = "external_service_reminder",
  INTERNAL_SERVICE_CREATED = "internal_service_created",
  EXTERNAL_SERVICE_CREATED = "external_service_created",
  INTERNAL_SERVICE_UPDATED = "internal_service_updated",
  EXTERNAL_SERVICE_UPDATED = "external_service_updated",
  INTERNAL_SERVICE = "internal_service",
  EXTERNAL_SERVICE = "external_service",
}

export type NotificationType = `${NOTIFICATION_TYPES}`;
